import React from 'react'

import TopSection from './TopSection'
import OurWork from './OurWork'

const index = ({projectDetails}) => {
    
  return (
    <div className="space-y-24">
        <section>
            <TopSection projectDetails={projectDetails}  />
        </section>

        <section className="flex flex-col justify-center items-start mt-24 text-[#333333]">
            <h2 className="font-bold text-2xl">Project Scope</h2>
            <p className="text-left mt-5 text-[#333333]/70">{projectDetails.projectScope}</p>
        </section>

        <section>
            <OurWork projectDetails={projectDetails} />
        </section>

        <section className="flex flex-col">
            <h2 className="font-bold text-2xl">Conclusion:</h2>
            <p className="text-left mt-5 text-[#333333]/70">{projectDetails.conclusion}</p>
        </section>
    </div>
  )
}

export default index